import { Attributes } from '../attributes';
import { SUB_CATEGORY } from '../categories';

export const EXTENDED_ATTRIBUTES_PREFIX = 'extended_attributes';

export const getAttributeTitleKey = (name, subCategoryId) =>
    `${getExtendedAttributeKey(name, subCategoryId)}.${Attributes.title}`;

export const getAttributeOptionKey = (name, option, subCategoryId) =>
    `${getExtendedAttributeKey(name, subCategoryId)}.${Attributes.options}.${option}`;

const getExtendedAttributeKey = (name, subCategoryId) =>
    `${EXTENDED_ATTRIBUTES_PREFIX}.${SUB_CATEGORY}_${subCategoryId}.${name}`;
